module.exports = __webpack_public_path__ + "static/media/login.766a228b.svg";